import { NEW_CLIENT, needsDomain } from '../lib/clientTarget.js'

/**
 * Cliente que recebe uma conta nos pickers de Google Ads e Meta Ads (#351): um cliente
 * existente ou um novo. Conta já vinculada (reconexão) fica no cliente atual e não troca.
 * Mostra o nome e a URL só quando precisam ser informados.
 */
export default function ClientTargetField({ row, clients, linkedClientId, disabled, onChange }) {
  const linked = !!linkedClientId
  const linkedKnown = linked && clients.some((c) => c.id === linkedClientId)
  const askDomain = needsDomain(row, clients)

  return (
    <>
      <div className="field" style={{ marginBottom: 10 }}>
        <label className="field-label">Cliente</label>
        <select
          className="input"
          value={row.client}
          onChange={(e) => onChange({ client: e.target.value })}
          disabled={disabled || linked}
        >
          {linked && !linkedKnown && <option value={linkedClientId}>Cliente atual da conta</option>}
          {clients.map((c) => (
            <option key={c.id} value={c.id}>{c.name}{c.is_self ? ' (principal)' : ''}</option>
          ))}
          <option value={NEW_CLIENT}>Criar novo cliente…</option>
        </select>
        {linked && (
          <small style={{ color: 'var(--ter)' }}>Esta conta já está vinculada a este cliente.</small>
        )}
      </div>
      {row.client === NEW_CLIENT && (
        <div className="field" style={{ marginBottom: 10 }}>
          <label className="field-label">Nome do novo cliente</label>
          <input
            className="input"
            value={row.newName || ''}
            onChange={(e) => onChange({ newName: e.target.value })}
            disabled={disabled}
          />
        </div>
      )}
      {askDomain && (
        <div className="field" style={{ marginBottom: 0 }}>
          <label className="field-label">URL do site do cliente</label>
          <input
            className="input"
            value={row.domain || ''}
            onChange={(e) => onChange({ domain: e.target.value })}
            disabled={disabled}
            placeholder="exemplo.com.br"
          />
        </div>
      )}
    </>
  )
}
